export default __webpack_public_path__ + "static/media/moves.60fcce12.webp";